import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PspTagListPayload, PspTagListResponseModel } from '@/models/psp-tag/psp-tag-list.model';
import { PspTagItem } from '@/models/psp-tag/psp-tag.model';

export default class GetPspTagListRequest extends ApiResourceMethod<PspTagListResponseModel> {
  public perform(payload: PspTagListPayload): Promise<PspTagListResponseModel> {
    return this.performer.requestWithMapper(
      { params: payload },
      ({ data, headers }: BaseResponse<PspTagItem[]>): PspTagListResponseModel => ({ data, headers }),
    );
  }
}
